import axios from 'axios'
import Mgr from '@/services/SecurityService'

export default class ApiService {

    async getAccessToken() {
        var user = new Mgr()
        var token = null
        await user.getUser().then(
            success => {
               token = success.access_token
            }, err => {
                console.log(err)
            })
        return token
    }

    async defineHeaderAxios() {
        var user = new Mgr()
        await user.getUser().then(
            success => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + success.access_token
            }, err => {
                console.log(err)
            })
    }

    async get(api) {
        await this.defineHeaderAxios()
        return axios
            .get(api)
            .then(response => response.data)
            .catch(err => {
                console.log(err);
            })
    }
    async post(api, model) {
        await this.defineHeaderAxios()
        return axios
            .post(api, model)
            .then(response => {
                return response
                })
            .catch(err => {
                console.log(err);
            })
    }
}